<template>
  <div>
    <h2>Бухгалтерские документы</h2>

    <p class="text-bold">
      Уважаемые партнеры!<br>
      В данном разделе Вы можете ознакомиться с закрывающими документами за каждый период работы с Demis Group.
    </p>
    <p>Закрывающие документы представлены такими первичными бухгалтерскими документами, как акт выполненных работ и счет-фактура за каждый период работы. Мы надеемся, что функционал данного раздела сделает взаимодействие между нашими компаниями еще более комфортным для Вас и Вашей бухгалтерии. Если Вы хотите перевести сверку приходов и расходов, у Вас есть возможность заказать акт сверки. После Вашего запроса, в течение 1 дня мы предоставим Вам документы.</p>

    <form class="form-inline margin-bottom">
      <div class="form-group">
        <button
          class="btn background-white border-danger text-danger"
          type="button"
          :disabled="!domainSelected || !documentsOrderPeriod"
          data-toggle="modal"
          :data-target="'#' + $getConst('DOCUMENTS_ORDER_MODAL_ID')"
        >
          Заказать акт сверки
        </button>
      </div>
      <c-select
        v-model="documentsOrderPeriod"
        title="ЗА ПЕРИОД:"
        form-group
        :options="periods"
      />
    </form>

    <c-box
      header-divider
      title="Акты выполненных работ и счета-фактуры"
      :loading="bookkeepingDocumentsLoading"
    >
      <template v-slot:header="{ title }">
        <h3
          class="box-title"
          v-text="title"
        />
      </template>
      <template v-slot:header-right>
        <c-select
          v-model="documentsListPeriod"
          :options="documentsListPeriods"
        />
      </template>
      <table
        v-if="bookkeepingDocuments.length"
        class="table"
      >
        <thead>
          <tr>
            <th>Документ</th>
            <th class="text-right">
              Дата создания
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="document in bookkeepingDocuments"
            :key="document.link"
          >
            <td>
              <div
                v-for="file in document.files"
                :key="file.link"
              >
                <a
                  class="file-link"
                  :href="joinImpersonate(joinClientId(file.link))"
                ><i class="fa fa-download" /> {{ file.name }}</a>
              </div>
            </td>
            <td class="text-right date">
              {{ new Date(document.year, document.month - 1) | moment('MMMM YYYY') | capitalizeFirstLetter }}
            </td>
          </tr>
        </tbody>
      </table>
      <no-data v-else />
    </c-box>
  </div>
</template>

<script>
import CSelect from '../../../../../../resources/js/components/ui/CSelect'
import CBox from '../../../../../../resources/js/components/ui/CBox'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { periods } from '../store/modules/forms/documentsOrder'
import { TYPE_BOOKKEEPING_DOCUMENTS } from '../store/modules/documents'
import moment from 'moment'
import NoData from '../../../../../../resources/js/components/NoData'
import modal from '../../../../../../resources/js/mixins/modal'
import { joinClientId, joinImpersonate } from '../../../../../../resources/js/helper'

export default {
  name: 'Document',
  components: {
    CSelect,
    CBox,
    NoData
  },
  mixins: [modal],
  data () {
    return {
      documentsListPeriod: '6',
      documentsListPeriods: {
        1: 'За прошедший месяц',
        3: 'За прошедшие 3 месяца',
        6: 'За прошедшие 6 месяцев',
        12: 'За прошедшие 12 месяцев'
      }
    }
  },
  computed: {
    /**
     * Период для заказа акта сверки.
     */
    documentsOrderPeriod: {
      get () {
        return this.$store.state.seo.forms.documentsOrder.period
      },
      set (value) {
        this.setDocumentsOrderPeriod(value)
      }
    },
    /**
     * Варианты периода для заказа акта сверки.
     *
     * @returns {[string, string, string]}
     */
    periods () {
      return periods
    },
    ...mapState({
      domainSelected: state => state.seo.client.domains.selected,
      bookkeepingDocuments: state => state.seo.documents.bookkeepingDocuments,
      bookkeepingDocumentsLoading: state => state.seo.documents.bookkeepingDocumentsLoading
    }),
    ...mapGetters({
      clientHasUnpaidDomains: 'seo/client/unpaidDomains/hasUnpaidDomains'
    })
  },
  watch: {
    documentsListPeriod () {
      this.fetchDocuments()
    }
  },
  mounted () {
    this.showNoMoney()
    this.$root.$on('clientUnpaidDomainsLoaded', this.showNoMoney)

    if (this.domainSelected) {
      this.fetchDocuments()
    }
    this.$root.$on('clientDomainsSelectedChange', this.fetchDocuments)
  },
  destroyed () {
    this.$root.$off('clientUnpaidDomainsLoaded', this.showNoMoney)
    this.$root.$off('clientDomainsSelectedChange', this.fetchDocuments)
  },
  methods: {
    /**
     * Загружает список документов.
     */
    fetchDocuments () {
      this.fetchClientExportDocumentsList({
        domain: this.domainSelected,
        type: TYPE_BOOKKEEPING_DOCUMENTS,
        from: moment().subtract(parseInt(this.documentsListPeriod), 'months'),
        to: moment()
      })
    },
    /**
     * Показывает уведомление о необходимости оплаты.
     */
    showNoMoney () {
      if (this.clientHasUnpaidDomains) {
        this.showModal(this.$getConst('NO_MONEY_MODAL_ID'))
      }
    },
    joinClientId (link) { return joinClientId(link) },
    joinImpersonate (url) { return joinImpersonate(url) },
    ...mapMutations({
      setDocumentsOrderPeriod: 'seo/forms/documentsOrder/setPeriod'
    }),
    ...mapActions({
      fetchClientExportDocumentsList: 'seo/documents/fetch',
      fetchClientUnpaidDomains: 'seo/client/unpaidDomains/fetch'
    })
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

.date {
  vertical-align: middle;
}

.fa-download {
  color: $textDangerColor;
}

.file-link {
  text-decoration: none;
}
</style>
